import { render, staticRenderFns } from "./relevancyTab.vue?vue&type=template&id=b19d8daa&scoped=true&"
import script from "./relevancyTab.vue?vue&type=script&lang=js&"
export * from "./relevancyTab.vue?vue&type=script&lang=js&"
import style0 from "./relevancyTab.vue?vue&type=style&index=0&id=b19d8daa&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19d8daa",
  null
  
)

export default component.exports